export default __webpack_public_path__ + "static/media/client-08.e1964efe.png";